function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    viewBox: "0 0 512 512",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#ebeef0",
    d: "M 511.5,111.5 C 511.5,187.5 511.5,263.5 511.5,339.5C 458.368,286.868 405.368,234.035 352.5,181C 336.868,170.694 321.535,171.027 306.5,182C 271.916,217.085 236.916,251.585 201.5,285.5C 191.035,275.535 180.702,265.369 170.5,255C 154.701,245.832 139.367,246.498 124.5,257C 82.9654,298.701 41.2987,340.201 -0.5,381.5C -0.5,291.167 -0.5,200.833 -0.5,110.5C 6.10101,85.4003 22.101,69.9003 47.5,64C 186.167,63.3333 324.833,63.3333 463.5,64C 489.347,70.0143 505.347,85.8476 511.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec10b",
    d: "M 97.5,127.5 C 122.926,125.615 139.759,136.615 148,160.5C 151.199,186.616 140.365,203.782 115.5,212C 88.3695,215.182 71.2028,203.682 64,177.5C 61.6387,159.908 67.4721,145.742 81.5,135C 86.8036,132.178 92.1369,129.678 97.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#388e3c",
    d: "M 511.5,339.5 C 511.5,359.5 511.5,379.5 511.5,399.5C 506.077,423.095 491.744,438.595 468.5,446C 433.207,447.467 397.874,447.967 362.5,447.5C 308.833,393.5 255.167,339.5 201.5,285.5C 236.916,251.585 271.916,217.085 306.5,182C 321.535,171.027 336.868,170.694 352.5,181C 405.368,234.035 458.368,286.868 511.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4caf50",
    d: "M 201.5,285.5 C 255.167,339.5 308.833,393.5 362.5,447.5C 257.499,447.667 152.499,447.5 47.5,447C 21.6224,440.955 5.6224,425.122 -0.5,399.5C -0.5,393.5 -0.5,387.5 -0.5,381.5C 41.2987,340.201 82.9654,298.701 124.5,257C 139.367,246.498 154.701,245.832 170.5,255C 180.702,265.369 191.035,275.535 201.5,285.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.9cdca81374266ce34749d465668f3461.svg";
export { ForwardRef as ReactComponent };